import urlParser from 'js-video-url-parser/lib/base';
import 'js-video-url-parser/lib/provider/vimeo';
import 'js-video-url-parser/lib/provider/youtube';

import { validMediaTypes, urlMediaFileType } from '@/utils/text';

export const pathParser = (to: any): any => {
  if (!to.path) {
    return {
      name: 'error',
      params: { code: 404 },
    };
  } else if (to.path === '/') {
    return {
      name: 'home',
    };
  } else {
    let path = decodeURIComponent(to.fullPath.substr(1) || '');

    let options = '';
    const options_parts = path.split('/@');

    if (options_parts.length > 1) {
      path = options_parts[0];
      options = options_parts.splice(1).join('@') || options;
      if (options.charAt(0) !== '/') {
        options = '/@' + options;
      }
    }

    // eslint-disable-next-line no-useless-escape
    if (/^(?!\.\.?$)(?!.*__.*__)([^\/]{1,1500})$/.test(path)) {
      return {
        name: 'video',
        params: { type: 'id', id: path, pathMatch: options },
      };
    }

    const provider_parse = urlParser.parse(path);

    if (
      provider_parse &&
      ['youtube', 'vimeo'].indexOf(provider_parse.provider) > -1 &&
      provider_parse.mediaType === 'video'
    ) {
      return {
        name: 'video',
        params: {
          type: provider_parse.provider,
          id: provider_parse.id,
          pathMatch: options,
        },
        query: {},
      };
    }

    const source_parse = urlMediaFileType(path);

    if (source_parse && validMediaTypes.hasOwnProperty(source_parse)) {
      return {
        name: 'video',
        params: {
          type: 'source',
          id: encodeURIComponent(path),
          pathMatch: options,
        },
        query: {},
      };
    }

    return {
      name: 'error',
      params: { code: 404 },
    };
  }
};
